(function () {
  "use strict";

  const persistedBogosData = {
    gifts: [],
    allOffers: [],
    offersMeta: {},
    addGiftToCartFunc: null,
  };

  let bogosEventHandlersSetup = false;
  let currentBogosInstance = null;
  const pendingBogosEvents = [];

  function setupGlobalBogosListeners() {
    if (bogosEventHandlersSetup) return;
    bogosEventHandlersSetup = true;

    // console.log("[BogosUpsells] Setting up global BOGOS event listeners...");

    const captureAndHandle = (eventName, handler) => {
      const wrappedHandler = (e) => {
        // console.log(`[BogosUpsells] ${eventName} event captured:`, e.detail);
        if (currentBogosInstance) {
          handler(e);
        } else {
          const existingIndex = pendingBogosEvents.findIndex(
            pe => pe.eventName === eventName && 
            JSON.stringify(pe.detail) === JSON.stringify(e.detail)
          );
          if (existingIndex === -1) {
            pendingBogosEvents.push({ eventName, detail: e.detail });
          }
          setTimeout(() => {
            if (currentBogosInstance) {
              handler(e);
            }
          }, 200);
        }
      };
      document.addEventListener(eventName, wrappedHandler);
    };

    captureAndHandle("fg-gifts:show-slider", handleBogosGiftsEvent);
    captureAndHandle("fg-today-offer:render", handleBogosTodayOfferEvent);
    captureAndHandle("fg-today-offer:success", handleBogosSuccessEvent);
  }

  function handleBogosGiftsEvent(e) {
    // console.log("[BogosUpsells] BOGOS gifts event received:", e.detail);
    if (!currentBogosInstance) {
      // console.warn("[BogosUpsells] No instance available for gifts event, initializing...");
      setTimeout(() => {
        if (!currentBogosInstance) {
          initializeCartBogosUpsells();
        }
        // After initialization, process the event again
        if (currentBogosInstance && e.detail && e.detail.gifts && e.detail.addGiftToCartFunc) {
          currentBogosInstance.bogosGifts = e.detail.gifts;
          currentBogosInstance.addGiftToCartFunc = e.detail.addGiftToCartFunc;
          persistedBogosData.gifts = e.detail.gifts;
          persistedBogosData.addGiftToCartFunc = e.detail.addGiftToCartFunc;
          currentBogosInstance.fetchCartData().then(() => {
            currentBogosInstance.renderGiftTiers();
          });
        }
      }, 200);
      return;
    }

    if (e.detail && e.detail.gifts && e.detail.addGiftToCartFunc) {
      currentBogosInstance.bogosGifts = e.detail.gifts;
      currentBogosInstance.addGiftToCartFunc = e.detail.addGiftToCartFunc;
      // Persist to global storage
      persistedBogosData.gifts = e.detail.gifts;
      persistedBogosData.addGiftToCartFunc = e.detail.addGiftToCartFunc;
      
      // Fetch cart data and render
      currentBogosInstance.fetchCartData().then(() => {
        currentBogosInstance.renderGiftTiers();
      });
    }
  }

  function handleBogosTodayOfferEvent(e) {
    // console.log("[BogosUpsells] BOGOS today offer render event:", e.detail);
    if (!currentBogosInstance) {
      // console.warn("[BogosUpsells] No instance available, initializing...");
      setTimeout(() => {
        if (!currentBogosInstance) {
          initializeCartBogosUpsells();
        }
        if (currentBogosInstance && e.detail && e.detail.todayOffers && e.detail.todayOffers.length > 0) {
          setTimeout(() => handleBogosTodayOfferEvent(e), 200);
        }
      }, 100);
      return;
    }

    if (
      e.detail &&
      e.detail.todayOffers &&
      e.detail.todayOffers.length > 0
    ) {
      // console.log("[BogosUpsells] Received", e.detail.todayOffers.length, "offers from BOGOS");
      // Store ALL offers (locked and unlocked)
      currentBogosInstance.allOffers = e.detail.todayOffers;
      
      // Flatten all gifts from all offers
      const allGifts = [];
      currentBogosInstance.offersMeta = {};
      e.detail.todayOffers.forEach((offer) => {
        const idStr = String(offer.id);
        
        // Special logging for offer 135287
        if (idStr === "135287") {
          console.log("[BogosUpsells] ===== OFFER 135287 DETAILS =====");
          console.log("[BogosUpsells] Full offer object:", JSON.parse(JSON.stringify(offer)));
          console.log("[BogosUpsells] Offer gifts count:", offer.gifts?.length || 0);
          if (offer.gifts && offer.gifts.length > 0) {
            console.log("[BogosUpsells] All gifts from offer 135287:", JSON.parse(JSON.stringify(offer.gifts)));
            offer.gifts.forEach((gift, index) => {
              console.log(`[BogosUpsells] Gift ${index + 1} from offer 135287:`, JSON.parse(JSON.stringify(gift)));
            });
          }
        }
        
        if (offer.gifts && offer.gifts.length > 0) {
          offer.gifts.forEach((gift) => {
            gift.belongs_to_offer = idStr;
            allGifts.push(gift);
          });
        }
        // BOGOS doesn't provide threshold values in the offer object
        // Instead, they provide a `success` property that indicates if the offer is unlocked
        // Store the success status - this is the primary way BOGOS indicates unlock status
        const isUnlocked = offer.success === true;
        
        // Try to extract threshold if available (for display purposes)
        // But note: BOGOS typically doesn't provide this
        const parseThreshold = (val) => {
          if (val === null || typeof val === "undefined") return NaN;
          if (typeof val === "number") return val;
          if (typeof val === "string") {
            const match = val.replace(/,/g, "").match(/([0-9]+(?:\.[0-9]+)?)/);
            if (match) {
              const num = Number(match[1]);
              return isNaN(num) ? NaN : num;
            }
            return NaN;
          }
          return NaN;
        };

        let rawThreshold = undefined;
        if (typeof offer.threshold !== "undefined") rawThreshold = offer.threshold;
        else if (typeof offer.requirement !== "undefined") rawThreshold = offer.requirement;
        else if (typeof offer.minimum_cart_value !== "undefined") rawThreshold = offer.minimum_cart_value;
        else if (typeof offer.min_cart_value !== "undefined") rawThreshold = offer.min_cart_value;
        else if (typeof offer.cart_value_required !== "undefined") rawThreshold = offer.cart_value_required;
        else if (typeof offer.minSpend !== "undefined") rawThreshold = offer.minSpend;
        else if (typeof offer.minimum_spend !== "undefined") rawThreshold = offer.minimum_spend;
        else if (typeof offer.min_order_amount !== "undefined") rawThreshold = offer.min_order_amount;
        else if (typeof offer.min_cart_total !== "undefined") rawThreshold = offer.min_cart_total;

        const parsed = parseThreshold(rawThreshold);
        const threshold = isNaN(parsed) ? NaN : parsed;
        
        // Log offer details for debugging
        // console.log("[BogosUpsells] Parsing offer", {
        //   offerId: idStr,
        //   offerTitle: offer.title,
        //   success: offer.success,
        //   isUnlocked: isUnlocked,
        //   rawThreshold: rawThreshold,
        //   parsedThreshold: threshold,
        //   offerObject: offer
        // });
        
        currentBogosInstance.offersMeta[idStr] = {
          claimed: false,
          threshold: threshold, // May be NaN if BOGOS doesn't provide
          unlocked: isUnlocked // Use BOGOS's success property
        };
      });

      if (allGifts.length > 0) {
        currentBogosInstance.bogosGifts = allGifts;
      }
      
      persistedBogosData.gifts = allGifts;
      persistedBogosData.allOffers = currentBogosInstance.allOffers;
      persistedBogosData.offersMeta = { ...currentBogosInstance.offersMeta };
      
      // Fetch cart and render after we have offer data
      // Note: BOGOS determines unlock status server-side, but we also recalculate based on cart total
      currentBogosInstance.fetchCartData().then(() => {
        // Re-check unlock status from offers after cart fetch
        // Recalculate unlock status based on current cart total (handles decreases below threshold)
        if (currentBogosInstance.allOffers) {
          currentBogosInstance.allOffers.forEach(offer => {
            const offerId = String(offer.id);
            if (currentBogosInstance.offersMeta[offerId]) {
              // First use BOGOS's success property
              let unlocked = offer.success === true;
              
              // But also recalculate based on cart total vs threshold if we have threshold
              const threshold = currentBogosInstance.offersMeta[offerId].threshold;
              if (isFinite(threshold) && threshold > 0) {
                let thresholdCents = threshold;
                if (threshold < 10000) {
                  thresholdCents = Math.round(threshold * 100);
                }
                const calculatedUnlocked = currentBogosInstance.cartTotal >= thresholdCents;
                
                // Use calculated value if it differs from BOGOS (handles stale BOGOS data)
                if (calculatedUnlocked !== unlocked) {
                  // console.log("[BogosUpsells] Recalculating unlock status for offer", offerId, {
                  //   bogosSuccess: unlocked,
                  //   calculatedUnlocked: calculatedUnlocked,
                  //   cartTotal: currentBogosInstance.cartTotal,
                  //   threshold: thresholdCents
                  // });
                  unlocked = calculatedUnlocked;
                  // Update offer object too
                  offer.success = unlocked;
                }
              }
              
              currentBogosInstance.offersMeta[offerId].unlocked = unlocked;
            }
          });
        }
        currentBogosInstance.renderGiftTiers();
      });
    }
  }

  function handleBogosSuccessEvent(e) {
    // console.log("[BogosUpsells] BOGOS offer success:", e.detail);
    
    if (!currentBogosInstance) {
      if (e.detail && e.detail.idOffersSuccess && e.detail.idOffersSuccess.length > 0) {
        // console.log("[BogosUpsells] Success event received but no instance, initializing...");
        setTimeout(() => {
          if (!currentBogosInstance) {
            initializeCartBogosUpsells();
          }
          if (currentBogosInstance) {
            setTimeout(() => handleBogosSuccessEvent(e), 200);
          }
        }, 100);
      }
      return;
    }
    
    if (e.detail && e.detail.idOffersSuccess) {
      const successfulOfferIds = e.detail.idOffersSuccess.map(id => String(id));
      
      if (!currentBogosInstance.allOffers || currentBogosInstance.allOffers.length === 0) {
        const hasPersisted = persistedBogosData.allOffers && persistedBogosData.allOffers.length > 0;
        if (hasPersisted) {
          // console.log("[BogosUpsells] Restoring offers from persistence in success handler");
          currentBogosInstance.allOffers = [...persistedBogosData.allOffers];
          currentBogosInstance.bogosGifts = persistedBogosData.gifts ? [...persistedBogosData.gifts] : [];
          currentBogosInstance.offersMeta = persistedBogosData.offersMeta ? { ...persistedBogosData.offersMeta } : {};
        } else {
          // console.log("[BogosUpsells] Success event but no offers yet, triggering refresh...");
          currentBogosInstance.triggerBogosRefreshImmediate();
          setTimeout(() => {
            if (currentBogosInstance && (!currentBogosInstance.allOffers || currentBogosInstance.allOffers.length === 0)) {
              currentBogosInstance.triggerBogosRefreshImmediate();
            }
          }, 500);
          return;
        }
      }
      
      if (currentBogosInstance.allOffers && currentBogosInstance.allOffers.length > 0) {
        currentBogosInstance.allOffers.forEach(offer => {
          const offerId = String(offer.id);
          const isSuccessful = successfulOfferIds.includes(offerId);
          offer.success = isSuccessful;
          
          if (currentBogosInstance.offersMeta[offerId]) {
            currentBogosInstance.offersMeta[offerId].unlocked = isSuccessful;
            persistedBogosData.offersMeta[offerId] = { ...currentBogosInstance.offersMeta[offerId] };
          }
        });
        
        persistedBogosData.allOffers = [...currentBogosInstance.allOffers];
      }
      
      if (!currentBogosInstance) {
        return;
      }
      
      currentBogosInstance.fetchCartData().then(() => {
        if (currentBogosInstance) {
          currentBogosInstance.updateClaimedStatus(successfulOfferIds);
          currentBogosInstance.renderGiftTiers();
        }
      });
    }
  }

  class CartBogosUpsells {
    constructor() {
      this.swiper = null;
      this.bogosGifts = persistedBogosData.gifts ? [...persistedBogosData.gifts] : [];
      this.allOffers = persistedBogosData.allOffers ? [...persistedBogosData.allOffers] : [];
      this.groupedGifts = [];
      this.offersMeta = persistedBogosData.offersMeta ? { ...persistedBogosData.offersMeta } : {};
      this.cartTotal = 0;
      this.previousCartTotal = 0;
      this.cartItems = [];
      // Thresholds only - titles come from BOGOS API (offer.title)
      this.offerTitles = {
        145476: { threshold: 100 },
        145478: { threshold: 250 },
      };
      this.addGiftToCartFunc = persistedBogosData.addGiftToCartFunc || null;
      this.currentOfferId = null;
      this.containerClickHandler = null;
      this.cartUpdateUnsubscriber = null;
      this.init();
    }

    init() {
      // console.log("[BogosUpsells] Initializing...");
      
      currentBogosInstance = this;
      
      setupGlobalBogosListeners();
      
      this.setupEventListeners();
      this.setupCartUpdateListener();
      
      if (pendingBogosEvents.length > 0) {
        // console.log("[BogosUpsells] Replaying", pendingBogosEvents.length, "pending BOGOS events");
        const eventsToReplay = [...pendingBogosEvents];
        pendingBogosEvents.length = 0;
        eventsToReplay.forEach(({ eventName, detail }) => {
          if (eventName === "fg-today-offer:render") {
            handleBogosTodayOfferEvent({ detail });
          } else if (eventName === "fg-today-offer:success") {
            handleBogosSuccessEvent({ detail });
          } else if (eventName === "fg-gifts:show-slider") {
            handleBogosGiftsEvent({ detail });
          }
        });
      }
      
      this.fetchCartData().then(() => {
        const hasPersistedOffers = persistedBogosData.allOffers && persistedBogosData.allOffers.length > 0;
        
        if (hasPersistedOffers && this.allOffers.length === 0) {
          // console.log("[BogosUpsells] Restoring persisted offers data...");
          this.allOffers = [...persistedBogosData.allOffers];
          this.bogosGifts = [...(persistedBogosData.gifts || [])];
          this.offersMeta = { ...persistedBogosData.offersMeta };
          this.addGiftToCartFunc = persistedBogosData.addGiftToCartFunc;
        }
        
        if (this.allOffers && this.allOffers.length > 0) {
          // console.log("[BogosUpsells] Has offers, re-rendering tiers...");
          this.renderGiftTiers();
        } else {
          // console.log("[BogosUpsells] No offers found, triggering BOGOS refresh...");
          this.triggerBogosRefreshImmediate();
          
          setTimeout(() => {
            if (!this.allOffers || this.allOffers.length === 0) {
              if (hasPersistedOffers) {
                // console.log("[BogosUpsells] Restoring persisted offers after refresh failed...");
                this.allOffers = [...persistedBogosData.allOffers];
                this.bogosGifts = [...(persistedBogosData.gifts || [])];
                this.offersMeta = { ...persistedBogosData.offersMeta };
                this.renderGiftTiers();
              } else {
                // console.log("[BogosUpsells] Still no offers after first refresh, retrying...");
                this.triggerBogosRefreshImmediate();
                
                setTimeout(() => {
                  if (!this.allOffers || this.allOffers.length === 0) {
                    // console.log("[BogosUpsells] No offers after retries, showing loading state");
                    this.renderGiftTiers();
                  }
                }, 1500);
              }
            }
          }, 1200);
        }
      });
      // console.log("[BogosUpsells] Initialization complete");
    }

    setupEventListeners() {
      // Use event delegation on document to survive DOM replacements
      // Instead of attaching to container directly, we check if event target is within container

      // Remove old handler if it exists
      if (this.containerClickHandler) {
        document.removeEventListener("click", this.containerClickHandler);
      }

      // Create new handler bound to this instance
      this.containerClickHandler = (e) => {
        // Check if click is within our container
        const container = e.target.closest(".cart-bogos-upsells-wrapper");
        if (!container) return;

        const toggleBtn = e.target.closest("[data-toggle-bogos]");
        if (toggleBtn) {
          this.toggleCollapse();
          return;
        }

        const tierBtn = e.target.closest("[data-open-bogos-tier]");
        if (tierBtn) {
          // Don't allow opening if disabled or locked
          if (tierBtn.disabled || tierBtn.dataset.locked === "true") {
            return;
          }
          const offerId = tierBtn.dataset.openBogosTier;
          this.openGiftOverlay(offerId);
          return;
        }

        const closeBtn = e.target.closest("[data-close-bogos-overlay]");
        if (closeBtn) {
          this.closeOverlay();
          return;
        }

        const sizeBtn = e.target.closest("[data-bogos-size]");
        if (sizeBtn) {
          this.handleSizeSelection(e);
          return;
        }

        const addBtn = e.target.closest("[data-add-bogos-gift]");
        if (addBtn) {
          this.handleAddGift(e);
          return;
        }
      };

      // Attach to document for event delegation (survives DOM replacement)
      document.addEventListener("click", this.containerClickHandler);

      // Initialize Swiper after a short delay to ensure DOM is ready
      setTimeout(() => this.initSwiper(), 100);
    }

    setupCartUpdateListener() {
      if (this.cartUpdateUnsubscriber && typeof this.cartUpdateUnsubscriber === "function") {
        this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = null;
      }

      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cartUpdateHandler = (event) => {
          if (event.source === "bogos-upsell") {
            return;
          }

          // console.log("[BogosUpsells] Cart update detected, refreshing...", event);

          const isEmpty = event.isEmpty === true || event.itemCount === 0;

          if (isEmpty) {
            // console.log("[BogosUpsells] Cart is empty (from event), hiding BOGOS wrapper");
            this.handleEmptyCart();
            return;
          }

          // Immediately fetch cart data and update UI - no delay for instant feedback
          this.fetchCartData().then((cart) => {
            if (!cart || !cart.items || cart.items.length === 0) {
              // console.log("[BogosUpsells] Cart is empty (from fetch), hiding BOGOS wrapper");
              this.handleEmptyCart();
              return;
            }

            const wrapper = document.querySelector(".cart-bogos-upsells-wrapper");
            if (wrapper) {
              wrapper.style.display = "";
              wrapper.style.visibility = "";
              wrapper.style.height = "";
              wrapper.style.overflow = "";
              wrapper.style.padding = "";
              wrapper.style.margin = "";
            }

            if (!this.allOffers || this.allOffers.length === 0) {
              const hasPersisted = persistedBogosData.allOffers && persistedBogosData.allOffers.length > 0;
              if (hasPersisted) {
                // console.log("[BogosUpsells] Restoring offers from persistence on cart update");
                this.allOffers = [...persistedBogosData.allOffers];
                this.bogosGifts = persistedBogosData.gifts ? [...persistedBogosData.gifts] : [];
                this.offersMeta = persistedBogosData.offersMeta ? { ...persistedBogosData.offersMeta } : {};
                this.addGiftToCartFunc = persistedBogosData.addGiftToCartFunc;
              }
            }

            // Immediately recalculate unlock status and update claimed status
            this.recalculateUnlockStatus();
            
            // Check for invalidated gifts and remove them smoothly
            this.handleInvalidatedGifts(cart);

            // Check claimed status immediately based on current cart
            this.updateClaimedStatusFromCart();

            // Re-render with smooth transitions
            this.renderGiftTiers();
          });

          // Trigger BOGOS refresh in background (non-blocking)
          this.triggerBogosRefreshImmediate();
        };

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, cartUpdateHandler);
      }
    }

    handleEmptyCart() {
      const wrapper = document.querySelector(".cart-bogos-upsells-wrapper");
      if (wrapper) {
        wrapper.style.display = "none";
        wrapper.style.visibility = "hidden";
        wrapper.style.height = "0";
        wrapper.style.overflow = "hidden";
        wrapper.style.padding = "0";
        wrapper.style.margin = "0";
      }
      this.bogosGifts = [];
      this.allOffers = [];
      this.offersMeta = {};
      this.cartTotal = 0;
      this.previousCartTotal = 0;
      this.cartItems = [];
    }

    recalculateUnlockStatus() {
      if (!this.allOffers || this.allOffers.length === 0) {
        const hasPersisted = persistedBogosData.allOffers && persistedBogosData.allOffers.length > 0;
        if (hasPersisted) {
          // console.log("[BogosUpsells] Restoring offers from persistence for recalculation");
          this.allOffers = [...persistedBogosData.allOffers];
          this.bogosGifts = persistedBogosData.gifts ? [...persistedBogosData.gifts] : [];
          this.offersMeta = persistedBogosData.offersMeta ? { ...persistedBogosData.offersMeta } : {};
        } else {
          // console.log("[BogosUpsells] No offers to recalculate");
          return;
        }
      }

      // Track previous cart total for comparison
      const previousCartTotal = this.previousCartTotal || this.cartTotal;
      const cartDecreased = this.cartTotal < previousCartTotal;
      const cartChanged = this.cartTotal !== previousCartTotal;

      // console.log("[BogosUpsells] Recalculating unlock status:", {
      //   cartTotal: this.cartTotal,
      //   cartTotalDollars: (this.cartTotal / 100).toFixed(2),
      //   previousCartTotal: previousCartTotal,
      //   previousCartTotalDollars: (previousCartTotal / 100).toFixed(2),
      //   cartDecreased,
      //   cartChanged,
      //   offerCount: this.allOffers.length
      // });

      let statusChangedCount = 0;

      this.allOffers.forEach(offer => {
        const offerId = String(offer.id);
        if (this.offersMeta[offerId]) {
          const wasUnlocked = this.offersMeta[offerId].unlocked;
          let nowUnlocked = false;

          // First check BOGOS success property
          if (typeof offer.success === "boolean") {
            nowUnlocked = offer.success === true;
          }

          // Get threshold from offersMeta or fallback to offerTitles
          let threshold = this.offersMeta[offerId]?.threshold;
          if (!threshold || !isFinite(threshold)) {
            const offerData = this.offerTitles[offerId];
            if (offerData && offerData.threshold) {
              threshold = offerData.threshold;
            }
          }
          
          if (isFinite(threshold) && threshold > 0) {
            // Convert threshold to cents if needed
            let thresholdCents = threshold;
            if (threshold < 10000) {
              thresholdCents = Math.round(threshold * 100);
            }
            const calculatedUnlocked = this.cartTotal >= thresholdCents;

            // console.log("[BogosUpsells] Threshold check for offer", offerId, {
            //   threshold: threshold,
            //   thresholdCents: thresholdCents,
            //   thresholdDollars: (thresholdCents / 100).toFixed(2),
            //   cartTotal: this.cartTotal,
            //   cartTotalDollars: (this.cartTotal / 100).toFixed(2),
            //   calculatedUnlocked,
            //   bogosSuccess: offer.success
            // });

            // If cart is clearly below threshold, mark as locked (overrides BOGOS)
            if (!calculatedUnlocked && this.cartTotal < thresholdCents) {
              nowUnlocked = false;
              offer.success = false;
              // console.log("[BogosUpsells] Marking offer", offerId, "as LOCKED (below threshold)");
            } else if (calculatedUnlocked && this.cartTotal >= thresholdCents) {
              // If cart meets threshold, mark as unlocked
              nowUnlocked = true;
              offer.success = true;
              // console.log("[BogosUpsells] Marking offer", offerId, "as UNLOCKED (meets threshold)");
            }
          } else {
            // No threshold from BOGOS - use heuristics
            // console.log("[BogosUpsells] No threshold for offer", offerId, "using heuristics");

            // If cart decreased significantly and offer was unlocked, check if it should be locked
            if (cartDecreased && wasUnlocked && this.cartTotal < previousCartTotal) {
              // If cart decreased by more than 5%, and was previously unlocked,
              // mark as locked if BOGOS still says unlocked (stale data)
              const decreasePercent = ((previousCartTotal - this.cartTotal) / previousCartTotal) * 100;
              if (decreasePercent > 5 && nowUnlocked) {
                // BOGOS says unlocked but cart decreased significantly - likely stale
                // Mark as locked to be safe (will update when BOGOS refreshes)
                // console.log("[BogosUpsells] Cart decreased significantly, marking offer as locked (pending BOGOS refresh)", {
                //   offerId,
                //   cartTotal: this.cartTotal,
                //   previousCartTotal,
                //   decreasePercent: decreasePercent.toFixed(2)
                // });
                nowUnlocked = false;
                offer.success = false;
              }
            }
          }

          // Update unlock status
          this.offersMeta[offerId].unlocked = nowUnlocked;
          offer.success = nowUnlocked;
          persistedBogosData.offersMeta[offerId] = this.offersMeta[offerId];

          if (wasUnlocked !== nowUnlocked) {
            statusChangedCount++;
            // console.log("[BogosUpsells] ⚠️ Unlock status CHANGED for offer", offerId, {
            //   wasUnlocked,
            //   nowUnlocked,
            //   cartTotal: this.cartTotal,
            //   cartTotalDollars: (this.cartTotal / 100).toFixed(2),
            //   previousCartTotal: previousCartTotal,
            //   previousCartTotalDollars: (previousCartTotal / 100).toFixed(2),
            //   threshold: threshold
            // });
          }
        }
      });

      // console.log("[BogosUpsells] Recalculation complete:", {
      //   offersProcessed: this.allOffers.length,
      //   statusChangedCount: statusChangedCount
      // });

      // Store current cart total for next comparison
      this.previousCartTotal = this.cartTotal;
    }

    triggerBogosRefreshImmediate() {
      // console.log("[BogosUpsells] Triggering immediate BOGOS refresh...");
      
      const tryGetOffers = () => {
        if (typeof window.sca_fg_getTodayOffers === "function") {
          try {
            const offers = window.sca_fg_getTodayOffers();
            // console.log("[BogosUpsells] Got offers via direct API call:", offers);
            if (offers && Array.isArray(offers) && offers.length > 0) {
              return offers;
            }
          } catch (e) {
            // console.log("[BogosUpsells] BOGOS getTodayOffers error:", e);
          }
        }
        
        if (window.sca_fg_today_offers && Array.isArray(window.sca_fg_today_offers)) {
          // console.log("[BogosUpsells] Found offers in window.sca_fg_today_offers");
          return window.sca_fg_today_offers;
        }
        
        if (window.sca_fg_data && window.sca_fg_data.todayOffers) {
          // console.log("[BogosUpsells] Found offers in window.sca_fg_data");
          return window.sca_fg_data.todayOffers;
        }
        
        return null;
      };
      
      const offers = tryGetOffers();
      if (offers && offers.length > 0) {
        if (currentBogosInstance) {
          handleBogosTodayOfferEvent({ detail: { todayOffers: offers } });
          return;
        } else {
          const existingIndex = pendingBogosEvents.findIndex(
            pe => pe.eventName === "fg-today-offer:render"
          );
          if (existingIndex === -1) {
            pendingBogosEvents.push({ 
              eventName: "fg-today-offer:render", 
              detail: { todayOffers: offers } 
            });
          }
        }
      }
      
      if (typeof window.sca_fg_refresh === "function") {
        try {
          window.sca_fg_refresh();
          // console.log("[BogosUpsells] Called sca_fg_refresh()");
        } catch (e) {
          // console.log("[BogosUpsells] BOGOS refresh function error:", e);
        }
      }
      
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then(response => response.json())
        .then(cart => {
          // console.log("[BogosUpsells] Cart.js fetched, BOGOS should detect change");
          
          const refreshEvent = new CustomEvent("cart:updated", {
            detail: { source: "bogos-upsells", cart: cart }
          });
          document.dispatchEvent(refreshEvent);
          
          setTimeout(() => {
            if (typeof window.sca_fg_getTodayOffers === "function") {
              try {
                const offers = window.sca_fg_getTodayOffers();
                if (offers && Array.isArray(offers) && offers.length > 0) {
                  // console.log("[BogosUpsells] Got offers after cart fetch:", offers);
                  if (currentBogosInstance) {
                    handleBogosTodayOfferEvent({ detail: { todayOffers: offers } });
                  } else {
                    const existingIndex = pendingBogosEvents.findIndex(
                      pe => pe.eventName === "fg-today-offer:render"
                    );
                    if (existingIndex === -1) {
                      pendingBogosEvents.push({ 
                        eventName: "fg-today-offer:render", 
                        detail: { todayOffers: offers } 
                      });
                    }
                  }
                }
              } catch (e) {
                // console.log("[BogosUpsells] BOGOS getTodayOffers error (retry):", e);
              }
            }
          }, 300);
        })
        .catch(err => console.error("[BogosUpsells] Error refreshing cart:", err));
    }

    async fetchCartData() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cart = await response.json();
        
        // Calculate cart total excluding free gifts (check for various gift indicators)
        let cartTotalCents = 0;
        this.cartItems = cart.items || [];
        
        cart.items.forEach((item) => {
          // Exclude items that appear to be free gifts
          // Check various properties that might indicate a gift
          const isGift = item.properties?._tier_reward || 
                        item.properties?.freegift || 
                        item.properties?._freegift ||
                        item.properties?.["_Free Gift"] ||
                        item.properties?.["Free Gift"] ||
                        (item.price === 0 && item.original_price > 0);
          
          if (!isGift) {
            // Use final_line_price (includes discounts) to match actual cart total
            // This is what Shopify considers the real cart value
            const itemTotal = item.final_line_price || item.line_price || (item.price * item.quantity);
            cartTotalCents += itemTotal;
            // console.log("[BogosUpsells] Cart item:", {
            //   title: item.product_title,
            //   variant: item.variant_title,
            //   quantity: item.quantity,
            //   price: item.price,
            //   linePrice: item.line_price,
            //   finalLinePrice: item.final_line_price,
            //   itemTotal: itemTotal,
            //   isGift: false
            // });
          } else {
            // console.log("[BogosUpsells] Excluding gift item:", {
            //   title: item.product_title,
            //   properties: item.properties
            // });
          }
        });
        
        this.cartTotal = cartTotalCents;
        // console.log("[BogosUpsells] Cart total (excluding gifts):", {
        //   totalCents: this.cartTotal,
        //   totalDollars: (this.cartTotal / 100).toFixed(2),
        //   itemCount: cart.items.length,
        //   cartItems: cart.items
        // });
        
        return cart;
      } catch (error) {
        console.error("[BogosUpsells] Error fetching cart:", error);
        return null;
      }
    }

    isGiftVariantInCart(variantId) {
      if (!this.cartItems || this.cartItems.length === 0) return false;
      
      // Check if this variant is actually in the cart
      const variantIdNum = parseInt(variantId);
      return this.cartItems.some((item) => {
        return item.variant_id === variantIdNum;
      });
    }

    checkOfferUnlocked(offerId) {
      const offerIdStr = String(offerId);
      const offerMeta = this.offersMeta[offerIdStr];
      
      // BOGOS provides unlock status via the `success` property in the offer object
      // This is the primary and most reliable way to determine if an offer is unlocked
      if (offerMeta && typeof offerMeta.unlocked === "boolean") {
        return offerMeta.unlocked;
      }
      
      // Fallback: Calculate unlock status from threshold
      let rawThreshold = null;
      
      // First check offersMeta for threshold
      if (offerMeta && isFinite(offerMeta.threshold)) {
        rawThreshold = offerMeta.threshold;
      }
      
      // Fallback to offerTitles if offersMeta doesn't have threshold
      if (!rawThreshold || !isFinite(rawThreshold)) {
        const offerData = this.offerTitles[offerIdStr];
        if (offerData && offerData.threshold) {
          rawThreshold = offerData.threshold;
        }
      }
      
      if (!rawThreshold || !isFinite(rawThreshold)) {
        // No threshold available -> treat as locked
        return false;
      }
      
      // Convert threshold from dollars to cents if needed
      let thresholdCents;
      if (rawThreshold >= 10000) {
        thresholdCents = Math.round(rawThreshold);
      } else {
        thresholdCents = Math.round(rawThreshold * 100);
      }
      
      if (!isFinite(thresholdCents) || thresholdCents <= 0) {
        return false;
      }
      
      // Compare cart total (already excludes discounts) to threshold
      const unlocked = this.cartTotal >= thresholdCents;
      return unlocked;
    }

    getAmountNeeded(offerId) {
      const offerIdStr = String(offerId);
      let rawThreshold = null;
      
      // First check offersMeta for threshold
      const offerMeta = this.offersMeta[offerIdStr];
      if (offerMeta && isFinite(offerMeta.threshold)) {
        rawThreshold = offerMeta.threshold;
      }
      
      // Fallback to offerTitles if offersMeta doesn't have threshold
      if (!rawThreshold || !isFinite(rawThreshold)) {
        const offerData = this.offerTitles[offerIdStr];
        if (offerData && offerData.threshold) {
          rawThreshold = offerData.threshold;
        }
      }
      
      if (!rawThreshold || !isFinite(rawThreshold)) {
        return 0;
      }
      
      // Convert threshold to cents (assume dollars if < 10000)
      let thresholdCents;
      if (rawThreshold >= 10000) {
        thresholdCents = Math.round(rawThreshold);
      } else {
        thresholdCents = Math.round(rawThreshold * 100);
      }
      
      if (!isFinite(thresholdCents) || thresholdCents <= 0) return 0;
      
      // Calculate amount needed (cart total already excludes discounts via final_line_price)
      const needed = thresholdCents - this.cartTotal;
      const displayNeeded = needed > 0 ? needed : 0;
      
      return displayNeeded;
    }

    stripGiftIcon(text) {
      if (!text) return "";
      return String(text).replace(/🎁/g, "").trim();
    }

    renderGiftTiers() {
      // console.log("[BogosUpsells] Rendering gift tiers...", this.allOffers);

      // Check if wrapper still exists in DOM (Shopify may have removed it on empty cart)
      const wrapper = document.querySelector(".cart-bogos-upsells-wrapper");
      if (!wrapper) {
        // console.log("[BogosUpsells] Wrapper not found in DOM (likely empty cart)");
        return;
      }

      const tiersContainer = wrapper.querySelector("[data-bogos-tiers]");
      if (!tiersContainer) {
        console.error("[BogosUpsells] Tiers container not found");
        return;
      }

      // Handle empty cart - hide wrapper completely
      if (!this.cartItems || this.cartItems.length === 0) {
        // console.log("[BogosUpsells] Cart is empty, hiding wrapper");
        wrapper.style.display = "none";
        wrapper.style.visibility = "hidden";
        wrapper.style.height = "0";
        wrapper.style.overflow = "hidden";
        tiersContainer.innerHTML = "";
        return;
      }

      // Show wrapper if cart has items
      wrapper.style.display = "";
      wrapper.style.visibility = "";
      wrapper.style.height = "";
      wrapper.style.overflow = "";

      // Clear existing content immediately (no delay to avoid race conditions)
      tiersContainer.innerHTML = "";

      // If no offers at all, show empty state
      if (!this.allOffers || this.allOffers.length === 0) {
        if (!this.bogosGifts || this.bogosGifts.length === 0) {
          const hasItems = this.cartItems && this.cartItems.length > 0;
          if (hasItems) {
            tiersContainer.innerHTML = `
              <div class="cart-bogos-upsells__empty-state">
                Loading available gifts...
              </div>
            `;
            setTimeout(() => {
              this.triggerBogosRefreshImmediate();
            }, 300);
          } else {
            tiersContainer.innerHTML = `
              <div class="cart-bogos-upsells__empty-state">
                No gifts available at this time.
              </div>
            `;
          }
          return;
        }
      }

      // Use allOffers if available, otherwise fall back to giftsByOffer
      const offersToRender = this.allOffers.length > 0 
        ? this.allOffers 
        : this.getAllOffersFromGifts();

      // Group gifts by offer for lookups
      const giftsByOffer = {};
      if (this.bogosGifts && this.bogosGifts.length > 0) {
        this.bogosGifts.forEach((gift) => {
          const offerId = String(gift.belongs_to_offer || "default");
          if (!giftsByOffer[offerId]) {
            giftsByOffer[offerId] = [];
          }
          giftsByOffer[offerId].push(gift);
        });
      }

      // Render each offer (show ALL offers, locked and unlocked)
      offersToRender.forEach((offer) => {
        const offerId = String(offer.id);
        const gifts = giftsByOffer[offerId] || [];
        
        // Check if offer is unlocked
        const isUnlocked = this.checkOfferUnlocked(offerId);
        const amountNeeded = this.getAmountNeeded(offerId);
        const isClaimed = this.isOfferClaimed(offerId);
        
        // Merge gifts into products with combined variants
        const grouped = gifts.length > 0 ? this.groupGiftsByProduct(gifts) : [];
        
        const firstGift = grouped[0];
        // Use title from BOGOS API (offer.title), fallback to gift title
        const displayTitle = this.truncateTitle(
          this.stripGiftIcon(
            offer.title || (firstGift ? firstGift.title : "Reward")
          )
        );
        
        const previewThumbs = grouped.length > 0
          ? grouped
              .slice(0, 3)
              .map(
                (p, idx) =>
                  `<img src="${p.thumbnail || p.variants?.[0]?.thumbnail || ""}"
                      alt=""
                      class="cart-bogos-upsells__tier-preview"
                      loading="lazy"
                      data-preview-index="${idx}" />`
              )
              .join("")
          : `<div class="cart-bogos-upsells__tier-preview-placeholder"></div>`;
        
        // Determine tier state classes
        let tierClasses = "cart-bogos-upsells__tier";
        if (isClaimed) {
          tierClasses += " claimed";
        } else if (isUnlocked) {
          tierClasses += " enabled";
        } else {
          tierClasses += " disabled";
        }
        
        // Value text - show amount needed if locked, or product count if unlocked
        let valueText = "";
        if (isClaimed) {
          valueText = "IN CART";
        } else if (!isUnlocked) {
          // Always show "Spend $xx to unlock" for locked offers
          const amountNeeded = this.getAmountNeeded(offerId);
          if (amountNeeded > 0) {
            const neededDollars = (amountNeeded / 100).toFixed(2);
            valueText = `Spend $${neededDollars} to unlock`;
          } else {
            // Fallback: try to get threshold from offerTitles or offersMeta
            const offerData = this.offerTitles[offerId];
            const threshold = offerData?.threshold || this.offersMeta[offerIdStr]?.threshold;
            if (threshold && isFinite(threshold)) {
              const thresholdCents = threshold >= 10000 ? Math.round(threshold) : Math.round(threshold * 100);
              const needed = thresholdCents - this.cartTotal;
              if (needed > 0) {
                const neededDollars = (needed / 100).toFixed(2);
                valueText = `Spend $${neededDollars} to unlock`;
              } else {
                valueText = "Available";
              }
            } else {
              valueText = "Available";
            }
          }
        } else if (grouped.length > 0) {
          valueText = `${grouped.length} product${grouped.length > 1 ? "s" : ""} available`;
        } else {
          valueText = "Available";
        }
        
        // Button text and state
        let buttonText = "CHOOSE YOUR GIFT →";
        let buttonDisabled = false;
        if (isClaimed) {
          buttonText = "IN CART ✓";
          buttonDisabled = true;
        } else if (!isUnlocked) {
          buttonText = "LOCKED";
          buttonDisabled = true;
        }
        
        const slideHtml = `
            <div class="swiper-slide">
              <div class="${tierClasses}" data-offer-id="${offerId}">
                <div class="cart-bogos-upsells__tier-product">
                  <div class="cart-bogos-upsells__tier-previews">
                    ${previewThumbs}
                  </div>
                  <div class="cart-bogos-upsells__tier-info">
                    <h4 class="cart-bogos-upsells__tier-title">${displayTitle}</h4>
                    <div class="cart-bogos-upsells__tier-value">${valueText}</div>
                  </div>
                </div>
                <button 
                  class="cart-bogos-upsells__tier-button"
                  data-open-bogos-tier="${offerId}"
                  ${buttonDisabled ? "disabled" : ""}
                  ${!isUnlocked && !isClaimed ? "data-locked='true'" : ""}
                >
                  ${buttonText}
                </button>
              </div>
            </div>
          `;
        tiersContainer.insertAdjacentHTML("beforeend", slideHtml);
      });

      // Update badge
      this.updateBadge(offersToRender.length);

      // Ensure DOM is ready before initializing Swiper
      // Use requestAnimationFrame to ensure all slides are in DOM
      requestAnimationFrame(() => {
        // Reinitialize Swiper after DOM updates
        // Always destroy and recreate to avoid stale references after DOM replacement
        this.initSwiper();

        // Auto-open accordion if we have unlocked offers and it's collapsed
        const hasUnlockedOffers = offersToRender.some(offer => {
          const offerId = String(offer.id);
          const isUnlocked = this.checkOfferUnlocked(offerId);
          const isClaimed = this.isOfferClaimed(offerId);
          return isUnlocked && !isClaimed;
        });

        if (hasUnlockedOffers) {
          this.ensureAccordionOpen();
        }
      });
    }

    ensureAccordionOpen() {
      const container = document.querySelector(".cart-bogos-upsells-wrapper");
      if (!container) {
        // console.log("[BogosUpsells] Cannot auto-open - container not found");
        return;
      }

      const header = container.querySelector("[data-toggle-bogos]");
      const content = container.querySelector(".cart-bogos-upsells__content");

      if (!header || !content) {
        // console.log("[BogosUpsells] Cannot auto-open - header or content not found", {
        //   header: !!header,
        //   content: !!content
        // });
        return;
      }

      const isCollapsed = header.classList.contains("collapsed");
      // console.log("[BogosUpsells] Accordion state:", {
      //   isCollapsed,
      //   willOpen: isCollapsed
      // });

      if (isCollapsed) {
        // console.log("[BogosUpsells] Auto-opening accordion - unlocked offers available");
        header.classList.remove("collapsed");
        content.classList.remove("collapsed");

        const badge = container.querySelector(".cart-bogos-upsells__badge");
        if (badge) {
          badge.style.display = "none";
        }
      } else {
        // console.log("[BogosUpsells] Accordion already open, no action needed");
      }
    }

    getAllOffersFromGifts() {
      // Fallback: create offer objects from gifts if allOffers not available
      const offersMap = {};
      if (this.bogosGifts && this.bogosGifts.length > 0) {
        this.bogosGifts.forEach((gift) => {
          const offerId = gift.belongs_to_offer || "default";
          if (!offersMap[offerId]) {
            // Use gift title from BOGOS API, fallback to "Reward"
            const title = gift.title || "Reward";
            offersMap[offerId] = {
              id: offerId,
              title: title,
              gifts: []
            };
          }
          offersMap[offerId].gifts.push(gift);
        });
      }
      return Object.values(offersMap);
    }

    isOfferClaimed(offerId) {
      // Check if any gift variants from this offer are actually in cart
      if (!this.bogosGifts || this.bogosGifts.length === 0) return false;
      
      const offerGifts = this.bogosGifts.filter(
        (g) => String(g.belongs_to_offer || "default") === String(offerId)
      );
      
      // Check if any variant from this offer's gifts is in cart
      for (const gift of offerGifts) {
        if (gift.variants && Array.isArray(gift.variants)) {
          for (const variant of gift.variants) {
            if (this.isGiftVariantInCart(variant.id)) {
              return true;
            }
          }
        }
      }
      
      return false;
    }

    getProductKey(gift) {
      // Prefer stable identifiers if present
      const variant =
        gift?.variants && gift.variants[0] ? gift.variants[0] : null;
      const productId = gift.product_id || variant?.product_id;
      const handle = gift.handle || variant?.product_handle;
      const title = this.stripGiftIcon(gift.title || "").toLowerCase();
      return (
        (productId && `id:${productId}`) ||
        (handle && `handle:${handle}`) ||
        `title:${title}`
      );
    }

    groupGiftsByProduct(gifts) {
      const map = {};
      gifts.forEach((g) => {
        const key = this.getProductKey(g);
        if (!map[key]) {
          map[key] = {
            title: this.stripGiftIcon(g.title),
            thumbnail: g.thumbnail || g.variants?.[0]?.thumbnail || "",
            variants: [],
            offerId: g.belongs_to_offer || "default",
            productId: g.id, // Store product ID for fetching variant data later
            handle: g.handle,
          };
        }
        // If this gift already has variants list, merge them; otherwise treat the first variant as unique
        const variantsToAdd =
          Array.isArray(g.variants) && g.variants.length > 0 ? g.variants : [];

        // If no variants array, try to construct a variant from the gift itself
        if (variantsToAdd.length === 0) {
          // Check if the gift object itself has variant-like properties
          const giftVariantId = g.id || g.variant_id || g.variantId;
          if (giftVariantId) {
            variantsToAdd.push({
              id: giftVariantId,
              title: g.variant_title || g.variantTitle || "Default",
              price: g.price !== undefined ? g.price : 0,
              original_price: g.original_price || g.originalPrice || g.compare_at_price,
              thumbnail: g.thumbnail || g.image
            });
          }
        }

        variantsToAdd.forEach((v) => {
          // Store both the variant ID and product ID for later resolution
          const variantData = {
            id: v.id,
            title: v.title,
            price: v.price,
            original_price: v.original_price,
            thumbnail: v.thumbnail,
            needsFetch: v.id === null || v.id === undefined, // Flag if we need to fetch real ID
            productId: g.id, // Store product ID for fetching
            handle: g.handle,
          };

          // Don't add duplicate variants (but null IDs are ok since we'll resolve them later)
          const existingIndex = map[key].variants.findIndex(
            (existing) => existing.id === v.id && existing.title === v.title
          );
          if (existingIndex === -1) {
            map[key].variants.push(variantData);
          }
        });
      });
      
      // Ensure at least one variant exists per product; if none, skip
      return Object.values(map).filter((p) => p.variants.length > 0);
    }

    async fetchVariantId(productHandle, variantTitle) {
      try {
        // console.log("[BogosUpsells] Fetching variant ID for product handle:", productHandle, "variant:", variantTitle);

        // productHandle should be the handle string, not the numeric ID
        if (!productHandle) {
          console.error("[BogosUpsells] No product handle provided");
          return null;
        }

        const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
        if (!response.ok) {
          console.error("[BogosUpsells] Failed to fetch product data:", response.status);
          return null;
        }

        const productData = await response.json();
        // console.log("[BogosUpsells] Product data fetched:", productData);

        // Find variant matching the title, or use first variant if "Default Title"
        let matchingVariant = null;
        if (variantTitle === "Default Title" || !variantTitle) {
          matchingVariant = productData.variants?.[0];
        } else {
          matchingVariant = productData.variants?.find(
            (v) => v.title === variantTitle
          );
        }

        if (matchingVariant && matchingVariant.id) {
          // console.log("[BogosUpsells] Found variant ID:", matchingVariant.id);
          return matchingVariant.id;
        }

        // console.warn("[BogosUpsells] No matching variant found for title:", variantTitle);
        return null;
      } catch (error) {
        console.error("[BogosUpsells] Error fetching variant ID:", error);
        return null;
      }
    }

    async fetchVariantAvailability(variantId) {
      try {
        if (!variantId) return { available: false, inventory_quantity: 0 };

        // Fetch variant availability from Shopify product API
        // We need to find the product handle first, then check the variant
        // For now, try to get it from cart or use a direct variant lookup
        // Shopify doesn't have a direct variant API, so we'll check via product
        
        // Try to get variant info from cart if available
        if (this.cartItems && this.cartItems.length > 0) {
          const cartVariant = this.cartItems.find(item => item.variant_id === parseInt(variantId));
          if (cartVariant) {
            // Variant is in cart, so it was available at some point
            // But we still need to check current availability
          }
        }

        // Since Shopify doesn't expose variant availability directly via JS API,
        // we'll use a workaround: try to add 0 quantity to check availability
        // Or better: fetch the product and check variant availability
        // For now, return a conservative check - assume available unless we can prove otherwise
        return { available: true, inventory_quantity: null };
      } catch (error) {
        console.error("[BogosUpsells] Error checking variant availability:", error);
        return { available: false, inventory_quantity: 0 };
      }
    } 

    async fetchProductVariantsAvailability(productHandle, logForOffer = null) {
      try {
        if (!productHandle) {
          return { availabilityMap: {}, productData: null };
        }

        const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
        if (!response.ok) {
          console.error("[BogosUpsells] Failed to fetch product data for availability:", response.status);
          return { availabilityMap: {}, productData: null };
        }

        const productData = await response.json();
        
        // Log raw product data for offer 135287
        if (logForOffer === "135287") {
          console.log("[BogosUpsells] ===== RAW PRODUCT DATA FROM SHOPIFY FOR OFFER 135287 =====");
          console.log("[BogosUpsells] Product handle:", productHandle);
          console.log("[BogosUpsells] Product ID:", productData.id);
          console.log("[BogosUpsells] Product title:", productData.title);
          console.log("[BogosUpsells] Total variants:", productData.variants?.length);
          console.log("[BogosUpsells] All variants raw data:", productData.variants?.map(v => ({
            id: v.id,
            title: v.title,
            available: v.available,
            inventory_quantity: v.inventory_quantity,
            inventory_policy: v.inventory_policy,
            inventory_management: v.inventory_management
          })));
        }
        
        const availabilityMap = {};

        if (productData.variants && Array.isArray(productData.variants)) {
          productData.variants.forEach((variant) => {
            // Check if variant is available
            // Shopify product.js includes: available, inventory_quantity, inventory_management, inventory_policy
            const isAvailable = variant.available === true;
            const inventoryQuantity = variant.inventory_quantity || 0;
            const inventoryPolicy = variant.inventory_policy || 'deny';
            const inventoryManagement = variant.inventory_management || null;

            // Variant is available if:
            // 1. available === true, OR
            // 2. inventory_policy === 'continue' (allow backorders), OR
            // 3. inventory_quantity > 0
            const available = isAvailable || 
                             inventoryPolicy === 'continue' || 
                             (inventoryManagement && inventoryQuantity > 0) ||
                             (!inventoryManagement); // No inventory tracking = always available

            availabilityMap[variant.id] = {
              available: available,
              inventory_quantity: inventoryQuantity,
              inventory_policy: inventoryPolicy,
              inventory_management: inventoryManagement
            };
          });
        }

        return { availabilityMap, productData };
      } catch (error) {
        console.error("[BogosUpsells] Error fetching product variants availability:", error);
        return { availabilityMap: {}, productData: null };
      }
    }

      async openGiftOverlay(offerId) {
        // console.log("[BogosUpsells] Opening overlay for offer:", offerId);
        
        await this.fetchCartData();
        
        const isUnlocked = this.checkOfferUnlocked(String(offerId));
        if (!isUnlocked) {
          // console.log("[BogosUpsells] Cannot open overlay - offer is locked");
          this.recalculateUnlockStatus();
          this.renderGiftTiers();
          return;
        }

        // Query overlay elements before any async operations
        const container = document.querySelector(".cart-bogos-upsells-wrapper");
        if (!container) {
          console.error("[BogosUpsells] Container not found when opening overlay");
          return;
        }

        const overlay = container.querySelector("[data-bogos-overlay]");
        if (!overlay) {
          console.error("[BogosUpsells] Overlay not found");
          return;
        }

        // Immediately show overlay with fade-in animation
        overlay.classList.add("active");
        document.body.style.overflow = "hidden";
        
        // console.log("[BogosUpsells] Available gifts:", this.bogosGifts);

        this.currentOfferId = offerId;
        // Convert both to strings for comparison to handle number/string mismatch
        const offerIdStr = String(offerId);
        
        // Special logging for offer 135287
        if (offerIdStr === "135287") {
          console.log("[BogosUpsells] ===== OPENING OVERLAY FOR OFFER 135287 =====");
          console.log("[BogosUpsells] All bogosGifts:", this.bogosGifts);
        }
        
        const gifts = this.bogosGifts.filter((g) => {
          const giftOfferId = String(g.belongs_to_offer || "default");
          return giftOfferId === offerIdStr;
        });

        // Special logging for offer 135287 - filtered gifts
        if (offerIdStr === "135287") {
          console.log("[BogosUpsells] Filtered gifts for offer 135287:", JSON.parse(JSON.stringify(gifts)));
          console.log("[BogosUpsells] Number of gifts for offer 135287:", gifts.length);
        }

        // console.log("[BogosUpsells] Filtered gifts for offer:", gifts);
        // console.log("[BogosUpsells] Gift structure detail:", gifts.map(g => ({
        //   title: g.title,
        //   hasVariants: !!g.variants,
        //   variantsLength: g.variants?.length,
        //   firstVariant: g.variants?.[0],
        //   variantId: g.variants?.[0]?.id,
        //   id: g.id,
        //   product_id: g.product_id
        // })));

        const groupedProducts = this.groupGiftsByProduct(gifts);
        
        // Special logging for offer 135287 - grouped products
        if (offerIdStr === "135287") {
          console.log("[BogosUpsells] ===== GROUPED PRODUCTS FOR OFFER 135287 =====");
          console.log("[BogosUpsells] Number of grouped products:", groupedProducts.length);
          console.log("[BogosUpsells] All grouped products:", JSON.parse(JSON.stringify(groupedProducts)));
          groupedProducts.forEach((product, index) => {
            console.log(`[BogosUpsells] Product ${index + 1} from offer 135287:`, JSON.parse(JSON.stringify(product)));
          });
        }

        // console.log("[BogosUpsells] Grouped products:", groupedProducts);
        // console.log("[BogosUpsells] Grouped products detail:", groupedProducts.map(p => ({
        //   title: p.title,
        //   variantsCount: p.variants?.length,
        //   firstVariantId: p.variants?.[0]?.id
        // })));

        // Fetch real variant IDs and availability for all products
        await Promise.all(
          groupedProducts.map(async (product) => {
            const productHandle = product.handle;
            if (!productHandle) {
              console.error("[BogosUpsells] No product handle available for:", product.title);
              return;
            }

            // Special logging for offer 135287 products
            const isOffer135287 = offerIdStr === "135287";
            if (isOffer135287) {
              console.log("[BogosUpsells] ===== PROCESSING PRODUCT FOR OFFER 135287 =====");
              console.log("[BogosUpsells] Product:", product.title);
              console.log("[BogosUpsells] Product handle:", productHandle);
              console.log("[BogosUpsells] Product variants before fetch:", JSON.parse(JSON.stringify(product.variants)));
            }

            // Fetch variant IDs for any null IDs
            const variantsToFetch = product.variants.filter((v) => v.needsFetch);
            if (variantsToFetch.length > 0) {
              // console.log("[BogosUpsells] Fetching variant IDs for product:", product.title, "handle:", productHandle);

              await Promise.all(
                variantsToFetch.map(async (variant) => {
                  const realVariantId = await this.fetchVariantId(
                    productHandle,
                    variant.title
                  );
                  if (realVariantId) {
                    variant.id = realVariantId;
                    variant.needsFetch = false;
                    // console.log("[BogosUpsells] Updated variant ID:", {
                    //   productTitle: product.title,
                    //   variantTitle: variant.title,
                    //   newId: realVariantId
                    // });
                  }
                })
              );
            }

            // Fetch availability for all variants AND get full product data
            const { availabilityMap, productData } = await this.fetchProductVariantsAvailability(productHandle, isOffer135287 ? offerIdStr : null);
            
            // Special logging for offer 135287 - availability map
            if (isOffer135287) {
              console.log("[BogosUpsells] ===== AVAILABILITY MAP FOR OFFER 135287 PRODUCT =====");
              console.log("[BogosUpsells] Product:", product.title);
              console.log("[BogosUpsells] Product handle:", productHandle);
              console.log("[BogosUpsells] Full availability map:", JSON.parse(JSON.stringify(availabilityMap)));
              console.log("[BogosUpsells] Availability map keys (variant IDs):", Object.keys(availabilityMap));
              Object.keys(availabilityMap).forEach(variantId => {
                const avail = availabilityMap[variantId];
                console.log(`[BogosUpsells] Variant ${variantId} availability:`, {
                  available: avail.available,
                  inventory_quantity: avail.inventory_quantity,
                  inventory_policy: avail.inventory_policy,
                  inventory_management: avail.inventory_management
                });
              });
            }
            
            // If we have full product data from Shopify, replace variants with ALL variants
            // This ensures we show all variants (including unavailable ones) in the size selector
            if (productData && productData.variants && Array.isArray(productData.variants) && productData.variants.length > 0) {
              // Create a map of existing variants by ID to preserve any BOGOS-specific data
              const existingVariantsMap = {};
              product.variants.forEach(v => {
                if (v.id) {
                  existingVariantsMap[v.id] = v;
                }
              });
              
              // Replace with all variants from Shopify
              product.variants = productData.variants.map((shopifyVariant) => {
                // Check if we already have this variant from BOGOS
                const existingVariant = existingVariantsMap[shopifyVariant.id];
                
                if (existingVariant) {
                  // Use existing variant but update availability
                  existingVariant.availability = availabilityMap[shopifyVariant.id] || { 
                    available: shopifyVariant.available !== false, 
                    inventory_quantity: shopifyVariant.inventory_quantity || 0 
                  };
                  return existingVariant;
                } else {
                  // Create new variant entry from Shopify data
                  return {
                    id: shopifyVariant.id,
                    title: shopifyVariant.title,
                    price: shopifyVariant.price || 0,
                    original_price: shopifyVariant.compare_at_price || shopifyVariant.price || 0,
                    thumbnail: shopifyVariant.featured_image || product.thumbnail || "",
                    availability: availabilityMap[shopifyVariant.id] || { 
                      available: shopifyVariant.available !== false, 
                      inventory_quantity: shopifyVariant.inventory_quantity || 0 
                    },
                    needsFetch: false
                  };
                }
              });
              
              if (isOffer135287) {
                console.log("[BogosUpsells] ===== REPLACED VARIANTS WITH ALL SHOPIFY VARIANTS =====");
                console.log("[BogosUpsells] Product:", product.title);
                console.log("[BogosUpsells] Total variants now:", product.variants.length);
                console.log("[BogosUpsells] Variants:", product.variants.map(v => ({
                  id: v.id,
                  title: v.title,
                  available: v.availability?.available,
                  inventory_quantity: v.availability?.inventory_quantity
                })));
              }
            } else {
              // Fallback: just apply availability to existing variants
              product.variants.forEach((variant) => {
                if (variant.id && availabilityMap[variant.id]) {
                  variant.availability = availabilityMap[variant.id];
                  if (isOffer135287) {
                    console.log("[BogosUpsells] Applied availability to variant:", {
                      variantId: variant.id,
                      variantTitle: variant.title,
                      available: variant.availability.available,
                      inventory_quantity: variant.availability.inventory_quantity
                    });
                  }
                } else {
                  // Default to available if we can't determine (conservative approach)
                  variant.availability = { available: true, inventory_quantity: null };
                  if (isOffer135287) {
                    console.warn("[BogosUpsells] ⚠️ Variant availability not found in map for offer 135287:", {
                      variantId: variant.id,
                      variantTitle: variant.title,
                      availableVariantIds: Object.keys(availabilityMap)
                    });
                  }
                }
              });
            }
            
            // Log final product with all variant data for offer 135287
            if (isOffer135287) {
              console.log("[BogosUpsells] ===== FINAL PRODUCT WITH AVAILABILITY FOR OFFER 135287 =====");
              console.log("[BogosUpsells] Product:", product.title);
              console.log("[BogosUpsells] Full product object:", JSON.parse(JSON.stringify(product)));
              console.log("[BogosUpsells] Variants summary:", product.variants.map(v => ({
                id: v.id,
                title: v.title,
                available: v.availability?.available,
                inventory_quantity: v.availability?.inventory_quantity
              })));
            }
          })
        );

        // console.log("[BogosUpsells] Grouped products after fetch:", groupedProducts);
        // console.log("[BogosUpsells] Grouped products detail after fetch:", groupedProducts.map(p => ({
        //   title: p.title,
        //   variantsCount: p.variants?.length,
        //   firstVariantId: p.variants?.[0]?.id,
        //   variants: p.variants.map(v => ({ title: v.title, id: v.id }))
        // })));

        // Get overlay products container (overlay already opened above)
        const overlayProducts = container.querySelector(
          "[data-bogos-overlay-products]"
        );

        if (!overlayProducts) {
          console.error("[BogosUpsells] Overlay products container not found");
          return;
        }

        if (groupedProducts.length === 0) {
          console.error("[BogosUpsells] No products to display in overlay");
          overlayProducts.innerHTML = `
            <div class="cart-bogos-upsells__empty-state">
              No products available for this offer.
            </div>
          `;
          return;
        }

        // Clear existing content immediately (overlay already visible)
        overlayProducts.innerHTML = "";

        // Populate products with staggered animations
        groupedProducts.forEach((product, index) => {
        // Filter out variants that still have null IDs
        const validVariants = product.variants.filter(
          (v) => v.id !== null && v.id !== undefined
        );

        // Skip products with no valid variants
        if (validVariants.length === 0) {
          // console.warn("[BogosUpsells] Skipping product with no valid variant IDs:", product.title);
          return;
        }

        // Update product variants to only include valid ones
        product.variants = validVariants;

        // Check availability - find first available variant for default
        const availableVariants = product.variants.filter(
          (v) => v.availability && v.availability.available !== false
        );

        // If no variants are available, skip this product entirely
        if (availableVariants.length === 0) {
          // console.warn("[BogosUpsells] Skipping product with no available variants:", product.title);
          return;
        }

        const hasMultipleVariants = product.variants.length > 1;
        
        // Use first available variant for single-variant products, or first variant if multiple
        const defaultVariant = availableVariants[0] || product.variants[0];
        const isDefaultAvailable = defaultVariant.availability && defaultVariant.availability.available !== false;

        const productHtml = `
            <div class="cart-bogos-upsells__product-item" data-bogos-product-id="${this.getProductKey(
              product
            )}">
              <div class="cart-bogos-upsells__product-row">
                <img
                  src="${
                    product.thumbnail || product.variants[0]?.thumbnail || ""
                  }"
                  alt="${this.stripGiftIcon(product.title)}"
                  class="cart-bogos-upsells__product-image"
                  loading="lazy"
                >
                <div class="cart-bogos-upsells__product-details">
                  <div class="cart-bogos-upsells__product-header">
                    <h3 class="cart-bogos-upsells__product-name">${this.stripGiftIcon(
                      product.title
                    ).toUpperCase()}</h3>
                    <div class="cart-bogos-upsells__product-price">
                      ${this.formatPrice(defaultVariant)}
                    </div>
                  </div>

                  ${
                    hasMultipleVariants
                      ? this.renderVariantSelector(product)
                      : ""
                  }

                  <button
                    class="cart-bogos-upsells__product-add-button"
                    data-add-bogos-gift
                    data-product-id="${this.getProductKey(product)}"
                    data-offer="${offerId}"
                    ${hasMultipleVariants || !isDefaultAvailable ? "disabled" : ""}
                    ${
                      !hasMultipleVariants && defaultVariant && defaultVariant.id && isDefaultAvailable
                        ? `data-variant-id="${defaultVariant.id}"`
                        : ""
                    }
                  >
                    ${
                      !isDefaultAvailable
                        ? "OUT OF STOCK"
                        : hasMultipleVariants
                        ? "WHAT'S YOUR SIZE?"
                        : "I WANT THIS →"
                    }
                  </button>
                </div>
              </div>
            </div>
            ${
              index < groupedProducts.length - 1
                ? `
              <div class="cart-bogos-upsells__divider">
                <div class="cart-bogos-upsells__divider-line"></div>
                <span class="cart-bogos-upsells__divider-text">OR</span>
                <div class="cart-bogos-upsells__divider-line"></div>
              </div>
            `
                : ""
            }
          `;

        overlayProducts.insertAdjacentHTML("beforeend", productHtml);
      });

      // Trigger reflow to ensure animations start
      void overlayProducts.offsetHeight;
    }

    renderVariantSelector(gift) {
      if (!gift.variants || gift.variants.length <= 1) return "";

      const sizesHtml = gift.variants
        .map(
          (variant) => {
            const isAvailable = variant.availability && variant.availability.available !== false;
            return `
          <button 
            class="cart-bogos-upsells__size-button ${!isAvailable ? 'disabled' : ''}" 
            data-bogos-size="${variant.title}"
            data-variant-id="${variant.id}"
            ${!isAvailable ? 'disabled' : ''}
            title="${!isAvailable ? 'Out of stock' : ''}"
          >
            ${variant.title}
          </button>
        `;
          }
        )
        .join("");

      return `
          <div class="cart-bogos-upsells__product-sizes" data-size-selector>
            ${sizesHtml}
          </div>
        `;
    }

    formatPrice(variant) {
      if (!variant) return "";

      let html = "";

      if (variant.original_price && variant.original_price > variant.price) {
        const originalPrice = variant.original_price;
        html += `<span class="cart-bogos-upsells__product-original-price">$${originalPrice}</span>`;
      }

      const price =
        variant.price === 0 ? "FREE" : this.formatMoney(variant.price);
      html += price;

      return html;
    }

    formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }

    truncateTitle(title, maxLength = 30) {
      if (title.length <= maxLength) return title;
      return title.substring(0, maxLength) + "...";
    }

      handleSizeSelection(e) {
        const sizeButton = e.target.closest("[data-bogos-size]");
        if (!sizeButton) return;

        // Don't allow selection of disabled/OOS variants
        if (sizeButton.disabled || sizeButton.classList.contains("disabled")) {
          return;
        }

        const productItem = sizeButton.closest("[data-bogos-product-id]");
        const container = document.querySelector(".cart-bogos-upsells-wrapper");
        const overlay = container?.querySelector("[data-bogos-overlay]");
        const addButton = productItem.querySelector("[data-add-bogos-gift]");

        // Clear all selections in overlay
        if (overlay) {
          overlay
            .querySelectorAll(".cart-bogos-upsells__size-button")
            .forEach((btn) => {
              btn.classList.remove("selected");
            });
        }

      // Mark as selected
      sizeButton.classList.add("selected");

      // Get variant ID
      const variantId = sizeButton.dataset.variantId;

      // Enable add button
      if (addButton && variantId) {
        addButton.textContent = "I WANT THIS →";
        addButton.disabled = false;
        addButton.dataset.variantId = variantId;
      }
    }

    async handleAddGift(e) {
      const button = e.target.closest("[data-add-bogos-gift]");
      if (!button || button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      // Double-check availability before adding (prevent race conditions)
      const productItem = button.closest("[data-bogos-product-id]");
      const sizeButton = productItem?.querySelector(`[data-bogos-size][data-variant-id="${variantId}"].selected`);
      if (sizeButton && (sizeButton.disabled || sizeButton.classList.contains("disabled"))) {
        console.warn("[BogosUpsells] Cannot add OOS variant:", variantId);
        button.textContent = "OUT OF STOCK";
        setTimeout(() => {
          button.textContent = "I WANT THIS →";
        }, 2000);
        return;
      }

      // Get offer ID from button data attribute (matching BOGOS pattern) or fallback to currentOfferId
      const offerId = button.dataset.offer || this.currentOfferId;
      if (productItem) {
        productItem.classList.add("loading");
      }

      const originalText = button.textContent;
      button.textContent = "ADDING...";
      button.disabled = true;

      try {
        // Try to get BOGOS function from multiple sources
        let addFn = this.addGiftToCartFunc;
        
        // Try persisted data
        if (!addFn && persistedBogosData && persistedBogosData.addGiftToCartFunc) {
          addFn = persistedBogosData.addGiftToCartFunc;
          this.addGiftToCartFunc = addFn;
        }
        
        // Try global BOGOS helper (FGSECOMAPP.helper.addGiftToCart)
        if (!addFn && typeof window.FGSECOMAPP !== "undefined" && 
            window.FGSECOMAPP.helper && 
            typeof window.FGSECOMAPP.helper.addGiftToCart === "function") {
          addFn = window.FGSECOMAPP.helper.addGiftToCart;
          this.addGiftToCartFunc = addFn;
        }

        // Use BOGOS's add function if available
        if (addFn && typeof addFn === "function") {
          console.log("[BogosUpsells] Using BOGOS function to add gift", {
            variantId: parseInt(variantId),
            quantity: 1,
            offerId: offerId ? String(offerId) : ""
          });
          // BOGOS expects: variantId (number), quantity (number), offerId (string)
          // BOGOS handles cart refresh internally, but we'll trigger our own update too
          const result = await addFn(parseInt(variantId), 1, offerId ? String(offerId) : "");
          console.log("[BogosUpsells] BOGOS function result", result);
          
          if (!result) {
            throw new Error("BOGOS function returned false - gift not added");
          }
          
          // Wait a bit for BOGOS to process, then trigger cart update
          await new Promise(resolve => setTimeout(resolve, 300));
          
          // Trigger cart update to refresh UI
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "bogos-upsell"
            });
          }
          
          // Also try to refresh cart via Shopify if available
          if (typeof Shopify !== "undefined" && typeof Shopify.getCart === "function") {
            try {
              await Shopify.getCart();
            } catch (e) {
              // Ignore errors
            }
          }
        } else {
          console.warn("[BogosUpsells] BOGOS function not available, using fallback", {
            hasInstanceFn: !!this.addGiftToCartFunc,
            hasPersistedFn: !!(persistedBogosData && persistedBogosData.addGiftToCartFunc),
            hasGlobalFn: !!(typeof window.FGSECOMAPP !== "undefined" && window.FGSECOMAPP.helper && window.FGSECOMAPP.helper.addGiftToCart)
          });
          // Fallback: add directly to cart using BOGOS format
          const config = typeof fetchConfig === "function" ? fetchConfig("javascript") : {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          };

          // Add BOGOS-specific headers and format
          const headers = {
            ...config.headers,
            "sca_add_gift": "1",
            "x-requested-with": "XMLHttpRequest",
          };

          const fetchUrl = `${window.Shopify.routes.root}cart/add.js?sca_add_gift`;
          const fetchBody = {
            items: [{
              id: parseInt(variantId),
              quantity: 1,
              properties: {}
            }],
            attributes: {
              "__freegift_attributes": "SECOMAPP_FREEGIFT",
              "__bogos_tracking": offerId ? String(offerId) : ""
            }
          };
          
          console.log("[BogosUpsells] Fallback fetch", {
            url: fetchUrl,
            headers: headers,
            body: fetchBody
          });
          
          const response = await fetch(fetchUrl, {
            ...config,
            headers: headers,
            body: JSON.stringify(fetchBody)
          });
          
          const responseData = await response.json();
          console.log("[BogosUpsells] Fallback fetch response", {
            ok: response.ok,
            status: response.status,
            data: responseData
          });
          
          if (!response.ok) {
            throw new Error(`Add to cart failed: ${response.status} ${response.statusText}`);
          }
          
          // Trigger cart update for fallback (BOGOS function handles it internally)
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "bogos-upsell"
            });
          }
        }

        button.textContent = "ADDED!";
        
        if (productItem) {
          productItem.classList.remove("loading");
        }

        // Wait before closing to allow cart UI to update and show success state
        setTimeout(() => {
          this.closeOverlay();
        }, 800);

      } catch (error) {
        console.error("[BogosUpsells] Error adding gift", error);
        
        if (productItem) {
          productItem.classList.remove("loading");
        }
        
        button.textContent = "ERROR - TRY AGAIN";
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    }

      toggleCollapse() {
        const container = document.querySelector(".cart-bogos-upsells-wrapper");
        if (!container) return;

        const header = container.querySelector("[data-toggle-bogos]");
        const content = container.querySelector(".cart-bogos-upsells__content");
        const badge = container.querySelector(".cart-bogos-upsells__badge");

        if (header && content) {
          const isNowCollapsed = !header.classList.contains("collapsed");
          header.classList.toggle("collapsed");
          content.classList.toggle("collapsed");

          if (badge) {
            badge.style.display = isNowCollapsed ? "flex" : "none";
          }
        }
      }

      closeOverlay() {
        // Try to find overlay in current container first, then fallback to document
        const container = document.querySelector(".cart-bogos-upsells-wrapper");
        const overlay = container?.querySelector("[data-bogos-overlay]") || document.querySelector("[data-bogos-overlay]");
        if (overlay) {
          // Fade out overlay smoothly
          overlay.classList.remove("active");
          
          // Reset body overflow after animation completes
          setTimeout(() => {
            if (document.body.style.overflow === "hidden") {
              document.body.style.overflow = "";
            }
          }, 300);
        } else {
          // Ensure body overflow is reset even if overlay element was removed
          if (document.body.style.overflow === "hidden") {
            document.body.style.overflow = "";
          }
        }
      }

    updateBadge(count) {
      const badge = document.querySelector(".cart-bogos-upsells__badge");
      if (!badge) return;

      if (count > 0) {
        badge.textContent = count;

        const header = document.querySelector("[data-toggle-bogos]");
        if (header && header.classList.contains("collapsed")) {
          badge.style.display = "flex";
        }
      } else {
        badge.style.display = "none";
      }
    }

    updateClaimedStatus(claimedOfferIds) {
      if (!claimedOfferIds || claimedOfferIds.length === 0) return;

      // Verify each offer by checking if variants are actually in cart
      claimedOfferIds.forEach((offerId) => {
        const offerIdStr = String(offerId);
        
        // Only mark as claimed if variants are actually in cart
        const isActuallyClaimed = this.isOfferClaimed(offerIdStr);
        
        if (isActuallyClaimed) {
          if (!this.offersMeta[offerIdStr]) {
            this.offersMeta[offerIdStr] = { claimed: false, unlocked: false };
          }
          this.offersMeta[offerIdStr].claimed = true;
          // Persist to global storage
          persistedBogosData.offersMeta[offerIdStr] = this.offersMeta[offerIdStr];
          
          // Update UI with smooth transition
          const tier = document.querySelector(`[data-offer-id="${offerIdStr}"]`);
          if (tier) {
            tier.classList.add("claimed");
            tier.classList.remove("enabled", "disabled");
            const button = tier.querySelector("[data-open-bogos-tier]");
            const valueEl = tier.querySelector(".cart-bogos-upsells__tier-value");
            if (button) {
              button.textContent = "IN CART ✓";
              button.setAttribute("disabled", "disabled");
            }
            if (valueEl) {
              valueEl.textContent = "IN CART";
            }
          }
        } else {
          // Not actually in cart - make sure we don't mark as claimed
          // console.log("[BogosUpsells] Offer", offerIdStr, "reported as claimed but not found in cart");
        }
      });
    }

    async handleInvalidatedGifts(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return;
      if (!this.allOffers || this.allOffers.length === 0) return;

      // Find all gift items in cart that are now invalid
      const invalidGiftItems = [];
      
      cart.items.forEach((item) => {
        // Check if this is a gift item
        const isGift = item.properties?._tier_reward || 
                      item.properties?.freegift || 
                      item.properties?._freegift ||
                      item.properties?.["_Free Gift"] ||
                      item.properties?.["Free Gift"] ||
                      (item.price === 0 && item.original_price > 0);
        
        if (!isGift) return;

        // Find which offer this gift belongs to
        let belongsToOffer = null;
        if (this.bogosGifts && this.bogosGifts.length > 0) {
          this.bogosGifts.forEach((gift) => {
            if (gift.variants && Array.isArray(gift.variants)) {
              gift.variants.forEach((variant) => {
                if (variant.id === item.variant_id) {
                  belongsToOffer = String(gift.belongs_to_offer || "default");
                }
              });
            }
          });
        }

        // Check if the offer is still unlocked
        if (belongsToOffer) {
          const isUnlocked = this.checkOfferUnlocked(belongsToOffer);
          if (!isUnlocked) {
            invalidGiftItems.push({
              item: item,
              line: item.key || item.id,
              variantId: item.variant_id,
              offerId: belongsToOffer
            });
          }
        }
      });

      // If we have invalid gifts, animate them out and remove them
      if (invalidGiftItems.length > 0) {
        console.log("[BogosUpsells] Found invalidated gifts, removing:", invalidGiftItems);
        
        for (const giftItem of invalidGiftItems) {
          await this.animateAndRemoveGiftItem(giftItem);
        }

        // Trigger cart refresh after removals
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "bogos-upsell-cleanup"
          });
        }
      }
    }

    async animateAndRemoveGiftItem(giftItem) {
      return new Promise((resolve) => {
        // Find the cart item element using multiple strategies
        let cartItem = null;
        
        // Strategy 1: Try to find by cart item key (if available)
        if (giftItem.line) {
          cartItem = document.querySelector(`[data-cart-item-key="${giftItem.line}"]`);
        }
        
        // Strategy 2: Find by CartDrawer-Item ID (uses 1-based index)
        if (!cartItem && giftItem.item.index !== undefined) {
          const itemId = `CartDrawer-Item-${giftItem.item.index + 1}`;
          cartItem = document.getElementById(itemId);
        }
        
        // Strategy 3: Find by variant ID in cart items
        if (!cartItem) {
          cartItem = Array.from(document.querySelectorAll('.cart-item')).find(item => {
            const link = item.querySelector('a[href*="/products/"]');
            if (link && giftItem.item.handle) {
              const href = link.getAttribute('href');
              return href.includes(giftItem.item.handle);
            }
            return false;
          });
        }
        
        // Strategy 4: Find by product title (fallback)
        if (!cartItem && giftItem.item.product_title) {
          cartItem = Array.from(document.querySelectorAll('.cart-item')).find(item => {
            const nameLink = item.querySelector('.cart-item__name');
            if (nameLink) {
              return nameLink.textContent.trim() === giftItem.item.product_title.trim();
            }
            return false;
          });
        }

        if (!cartItem) {
          console.warn("[BogosUpsells] Cart item element not found for gift:", giftItem);
          // Still try to remove via API
          this.removeGiftFromCart(giftItem.line || giftItem.item.key || giftItem.item.id).then(resolve);
          return;
        }

        // Add removing class to trigger animation
        cartItem.classList.add("removing");
        
        // Also add to parent row if it's a table row
        if (cartItem.tagName === 'TR') {
          cartItem.style.transition = "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)";
        }

        // Wait for animation to complete, then remove from cart
        setTimeout(async () => {
          await this.removeGiftFromCart(giftItem.line || giftItem.item.key || giftItem.item.id);
          resolve();
        }, 400); // Match animation duration
      });
    }

    async removeGiftFromCart(lineKey) {
      try {
        const config = typeof fetchConfig === "function" ? fetchConfig("javascript") : {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };

        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          ...config,
          body: JSON.stringify({
            id: lineKey,
            quantity: 0
          })
        });

        if (!response.ok) {
          console.error("[BogosUpsells] Failed to remove gift from cart:", response.status);
          return;
        }

        const cart = await response.json();
        
        // Update our cart data
        this.cartItems = cart.items || [];
        this.cartTotal = 0;
        cart.items.forEach((item) => {
          const isGift = item.properties?._tier_reward || 
                        item.properties?.freegift || 
                        item.properties?._freegift ||
                        item.properties?.["_Free Gift"] ||
                        item.properties?.["Free Gift"] ||
                        (item.price === 0 && item.original_price > 0);
          
          if (!isGift) {
            const itemTotal = item.final_line_price || item.line_price || (item.price * item.quantity);
            this.cartTotal += itemTotal;
          }
        });

        return cart;
      } catch (error) {
        console.error("[BogosUpsells] Error removing gift from cart:", error);
      }
    }

    updateClaimedStatusFromCart() {
      // Immediately check all offers against current cart state
      if (!this.allOffers || this.allOffers.length === 0) return;

      this.allOffers.forEach((offer) => {
        const offerIdStr = String(offer.id);
        const isActuallyClaimed = this.isOfferClaimed(offerIdStr);
        const wasClaimed = this.offersMeta[offerIdStr]?.claimed || false;

        if (isActuallyClaimed !== wasClaimed) {
          if (!this.offersMeta[offerIdStr]) {
            this.offersMeta[offerIdStr] = { claimed: false, unlocked: false };
          }
          this.offersMeta[offerIdStr].claimed = isActuallyClaimed;
          persistedBogosData.offersMeta[offerIdStr] = this.offersMeta[offerIdStr];

          // Update UI immediately with smooth transition
          const tier = document.querySelector(`[data-offer-id="${offerIdStr}"]`);
          if (tier) {
            if (isActuallyClaimed) {
              tier.classList.add("claimed");
              tier.classList.remove("enabled", "disabled");
              const button = tier.querySelector("[data-open-bogos-tier]");
              const valueEl = tier.querySelector(".cart-bogos-upsells__tier-value");
              if (button) {
                button.textContent = "IN CART ✓";
                button.setAttribute("disabled", "disabled");
              }
              if (valueEl) {
                valueEl.textContent = "IN CART";
              }
            } else {
              // No longer claimed - update to unlocked/locked state
              tier.classList.remove("claimed");
              const isUnlocked = this.checkOfferUnlocked(offerIdStr);
              if (isUnlocked) {
                tier.classList.add("enabled");
                tier.classList.remove("disabled");
              } else {
                tier.classList.add("disabled");
                tier.classList.remove("enabled");
              }
              const button = tier.querySelector("[data-open-bogos-tier]");
              const valueEl = tier.querySelector(".cart-bogos-upsells__tier-value");
              if (button) {
                button.removeAttribute("disabled");
                button.removeAttribute("data-locked");
                button.textContent = "CHOOSE YOUR GIFT →";
              }
              if (valueEl) {
                const amountNeeded = this.getAmountNeeded(offerIdStr);
                if (amountNeeded > 0) {
                  const neededDollars = (amountNeeded / 100).toFixed(2);
                  valueEl.textContent = `Spend $${neededDollars} to unlock`;
                } else {
                  valueEl.textContent = "Available";
                }
              }
            }
          }
        }
      });
    }

    initSwiper() {
      // Destroy existing Swiper first
      if (this.swiper && typeof this.swiper.destroy === "function") {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {
          // console.warn("[BogosUpsells] Error destroying Swiper:", e);
        }
        this.swiper = null;
      }

      const swiperContainer = document.querySelector(
        ".cart-bogos-upsells__swiper"
      );

      if (!swiperContainer) {
        // console.log("[BogosUpsells] Swiper container not found, will retry on next render");
        return;
      }

      if (typeof Swiper === "undefined") {
        // console.log("[BogosUpsells] Swiper library not ready, retrying...");
        setTimeout(() => this.initSwiper(), 200);
        return;
      }

      // Check if swiper has slides before initializing
      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        // console.log("[BogosUpsells] No slides found, skipping Swiper init");
        return;
      }

      try {
        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: "auto",
          spaceBetween: 12,
          slidesOffsetBefore: 12,
          slidesOffsetAfter: 12,
          freeMode: true,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
          },
          // Handle initialization errors gracefully
          on: {
            init: function() {
              // console.log("[BogosUpsells] Swiper initialized successfully");
            }
          }
        });
      } catch (error) {
        console.error("[BogosUpsells] Error initializing Swiper:", error);
        this.swiper = null;
      }
    }

    destroy() {
      // console.log("[BogosUpsells] Destroying instance...");

      // Close overlay if open
      this.closeOverlay();

      // Clear current instance reference
      if (currentBogosInstance === this) {
        currentBogosInstance = null;
      }

      // Destroy Swiper
      if (this.swiper && typeof this.swiper.destroy === "function") {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {
          // console.warn("[BogosUpsells] Error destroying Swiper:", e);
        }
        this.swiper = null;
      }

      // Remove click handler from document (event delegation)
      if (this.containerClickHandler) {
        document.removeEventListener("click", this.containerClickHandler);
        this.containerClickHandler = null;
      }

      // Unsubscribe from cart updates
      if (this.cartUpdateUnsubscriber && typeof this.cartUpdateUnsubscriber === "function") {
        this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = null;
      }
    }
  }

  let cartBogosUpsellsInstance = null;
  let initTimeout = null;
  let isInitializing = false;

  function initializeCartBogosUpsells() {
    if (initTimeout) {
      clearTimeout(initTimeout);
    }

    if (isInitializing) {
      return;
    }

    initTimeout = setTimeout(() => {
      if (isInitializing) {
        return;
      }
      
      isInitializing = true;
      // console.log("[BogosUpsells] Initializing...");

      if (
        cartBogosUpsellsInstance &&
        typeof cartBogosUpsellsInstance.destroy === "function"
      ) {
        cartBogosUpsellsInstance.destroy();
        cartBogosUpsellsInstance = null;
      }

      const element = document.querySelector(".cart-bogos-upsells-wrapper");

      if (element) {
        cartBogosUpsellsInstance = new CartBogosUpsells();
        window.cartBogosUpsellsInstance = cartBogosUpsellsInstance;
        // console.log("[BogosUpsells] Instance created");
        setTimeout(() => {
          isInitializing = false;
        }, 500);
      } else {
        // console.warn("[BogosUpsells] Container element not found");
        isInitializing = false;
      }
    }, 100);
  }

  function registerWithManager() {
    if (window.cartDrawerInitManager) {
      window.cartDrawerInitManager.registerInitCallback(
        initializeCartBogosUpsells,
        "CartBogosUpsells"
      );
      // console.log("[BogosUpsells] Registered with cart drawer manager");
      return true;
    }
    return false;
  }

  setupGlobalBogosListeners();

  if (!registerWithManager()) {
    const checkInterval = setInterval(() => {
      if (registerWithManager()) {
        clearInterval(checkInterval);
      }
    }, 100);
    setTimeout(() => clearInterval(checkInterval), 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCartBogosUpsells);
  } else {
    initializeCartBogosUpsells();
  }
})();